import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import App from './Controller'
import 'babel-polyfill';


ReactDOM.render(App, document.getElementById('root'));
serviceWorker.unregister();
